import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  FileUploadControl,
  FileUploadValidators,
} from '@iplab/ngx-file-upload';
import { DataService } from '../services/data.service';
import { CoreImageViewService } from '../services';
import { MAX_IMAGE_BYTES } from '../constants';
import { forkJoin, Observable } from 'rxjs';

@Component({
  selector: 'app-core-image-upload',
  templateUrl: './core-image-upload.component.html',
})
export class CoreImageUploadComponent {
  @Input() multiple: boolean = false;
  @Input() showSaveHint: boolean = false;
  @Output() imagesUploaded = new EventEmitter<any>();
  isUploading = false;

  get maxImageSize(): string {
    return (MAX_IMAGE_BYTES / (1024 * 1024)) + ' MB';
  }

  public readonly coreImageUploadControl = new FileUploadControl(
    { listVisible: true, accept: ['image/*'], discardInvalid: true },
    [
      FileUploadValidators.accept(['image/*']),
      FileUploadValidators.filesLimit(10),
      FileUploadValidators.fileSize(MAX_IMAGE_BYTES)
    ]
  );

  constructor(
    protected service: DataService,
    private coreImageView: CoreImageViewService
  ) {}

  uploadImages(entityType: string, entityId: number) {
    if (this.isUploading) {
      return;
    }

    if (!this.coreImageUploadControl.value.length) {
      this.imagesUploaded.emit({ status: 'success', data: [] });
      return;
    }

    this.isUploading = true;
    this.coreImageUploadControl.disable(true);

    const requests: Observable<any>[] = this.coreImageUploadControl.value.map(
      (image: File) => {
        const formData: FormData = new FormData();
        formData.append('image', image);
        return this.service.postFiles(
          this.getImageServiceUrl(entityType, entityId),
          formData
        );
      }
    );

    forkJoin(requests).subscribe(
      (allResults) => {
        this.coreImageView.invalidateCache(entityType, entityId);
        this.imagesUploaded.emit({ status: 'success', data: allResults });
        this.isUploading = false;
        this.coreImageUploadControl.disable(false);
        this.coreImageUploadControl.clear();
      },
      (error) => {
        this.imagesUploaded.emit({ status: 'error', data: error });
        this.isUploading = false;
        this.coreImageUploadControl.disable(false);
        this.coreImageUploadControl.clear();
      }
    );
  }

  getImageServiceUrl(entityType: string, entityId: number): string {
    return `api/core/images/${entityType}/${entityId}`;
  }
}
